// extracted by mini-css-extract-plugin
export default {"container":"styles_container__YlEQ6","texts":"styles_texts__XFTmK"};